<div class="header">
    <h3 mat-dialog-title>{{ 'Create Margin - ' + data?.candidateName }}</h3>
    <em (click)="closeDialog()" class="material-icons">
        close
    </em>
</div>

<div mat-dialog-content class="nova__dialog__content">
    <div class="margin-calculation-form-content">
        <mat-checkbox class="flex-13" name="insurance" [formControl]="insuranceFormCtrl"> Insurance </mat-checkbox>
    </div>
    <div class="info-container" [ngClass]="{ 'info-container__no-table': !tableDisplaying }">
        <div class="stipends-message">
            <span>
                <strong>*Max Stipends allowable</strong>
                is applied for calculating the estimated pre-tax weekly pay.
            </span>
        </div>
    </div>
    <div class="table-container">
        <nova-direct-offer-create-quote-margin *ngIf="offers.length > 0" [data]="offers" (quoteUpdated)="quotesUpdated($event)"></nova-direct-offer-create-quote-margin>
    </div>
    <div class="save-margin-btn-container">
        <button mat-flat-button (click)="saveMargin()"
            class="mat-raised-button next-btn next-btn--margin-right" 
            [ngClass]="{'next-btn--width next-btn--height': isSaving}"
            [disabled]="calcBtnLocked">
            <span *ngIf="!isSaving">CREATE MARGIN</span>
            <mat-progress-spinner *ngIf="isSaving" color="accent" mode="indeterminate" diameter="30">
            </mat-progress-spinner>
        </button>

        <button mat-flat-button class="mat-raised-button back-btn" (click)="closeDialog()">
            CANCEL
        </button>
    </div>
</div> 

